var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkiptime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "skiptime") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 3,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "32 12 32 32 49 32"
  }), /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    d: "M5.02,42.655A29.018,29.018,0,1,0,3,32"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "6.022 59.041 5 42.649 20.689 48.103"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiptime);
export default __webpack_public_path__ + "static/media/skiptime.56158d0e9950eb47b1874649d2054d61.svg";
export { ForwardRef as ReactComponent };